// GlidepathAllocationYearInputTextBox.js
import React, { useState } from 'react';
import DOMPurify from 'dompurify';

//import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

//import './GlidepathAllocationYearInputTextBox.css';

// Function to generate a unique ID
const generateUniqueId = () => {
	return 'id-' + new Date().getTime() + '-' + Math.floor(Math.random() * 1000);
};

const GlidepathAllocationYearInputTextBox = ({ onInputSubmit, GlidepathAllocationYearInputTextBoxLabels = {}, maxYear = 25 }) => {
	const [inputValue, setInputValue] = useState('');
	const [isButtonDisabled, setIsButtonDisabled] = useState(true);

	const { t } = useTranslation();
	const uniqueId = generateUniqueId();

	const minInputValue = 1;
	const maxInputValue = Number(maxYear);
	const handleChangeInput = (event) => {
		const value = event.target.value;

		// Check if the input value is a valid number
		if (/^-?\d*\.?\d*$/.test(value)) {
			setInputValue(value);

			const numValue = parseFloat(value);

			// Enable button only if number is between 0 and 10
			if (numValue >= minInputValue && numValue <= maxInputValue) {
				setIsButtonDisabled(false);
			} else {
				setIsButtonDisabled(true);
			}
		}
	};

	const handleKeyDown = (event) => {
		if (event.key === 'Enter' && !isButtonDisabled) {
			handleSubmitYear(); // Submit the form when Enter is pressed
		}
	};

	const handleSubmitYear = () => {
		if (!isButtonDisabled && onInputSubmit) {
			onInputSubmit(Number(inputValue)); // Pass the input value directly to the parent
		}
	};

	return (
		<div className="l-grid__row">
			<div className="l-grid__column-medium-12">
				<div className="lifecycle-input-area font-size-sm">
					<input className="input-year c-textinput__field" onKeyDown={handleKeyDown} onChange={handleChangeInput} type="text" min={minInputValue} max={maxInputValue} placeholder={t('yearInputTextBoxPlaceholder')} />
					<button className="submit-year c-button" onClick={handleSubmitYear} disabled={isButtonDisabled}>{t('yearInputTextBoxSubmit')}</button>
					{GlidepathAllocationYearInputTextBoxLabels.showInfo && (
						<>
							<i data-toggle="modal" data-trigger={`disclaimer-popup-${uniqueId}`} className='c-icon c-info-icon c-icon--info-circle-o u-margin-left-sm u-margin-top-sm font-size-lg'></i>
							<div id={`disclaimer-popup-${uniqueId}`} className="c-popup js-popup " tabIndex="-1" role="dialog">
								<div className="c-popup__dialog c-popup__dialog--disclaimer" role="document">
									<div className="c-popup__header">
										<span className="c-popup__close c-icon c-icon--close" data-dismiss="modal" aria-label={t('closeAriaLabel')}></span>
									</div>
									<div className="c-popup__body">
										<div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(GlidepathAllocationYearInputTextBoxLabels.infoPopupContent) }} />
									</div>
								</div>
							</div>
						</>
					)}
				</div>

				<div className="year-error-message c-message c-message--error u-hidden">
					<div className="c-message__content">
						<em aria-hidden='true' className='c-message__item-icon c-icon c-icon--info-circle'></em>
						<p className="c-copy c-message--error">{t('yearInputTextBoxErrorMessage')}</p>
					</div>
				</div>
			</div>
		</div>
	)
};

export default GlidepathAllocationYearInputTextBox;
